import { Toaster as SonnerToaster } from 'sonner';

export { toast } from 'sonner';

/**
 * Powiadomienia chwilowe (sonner). Desktop: prawy dolny róg; mobile: nad dolnym menu.
 * Fala 10: odstępy ze zmiennych CSS, które ustawia bąbel AI (`--fos-toast-right`, `--fos-toast-bottom`,
 * `--fos-toast-bottom-mobile`) — powiadomienie nie zasłania bąbla ani pola wiadomości przypiętego czatu; bez bąbla
 * (np. logowanie) wartości domyślne jak wcześniej.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      gap={8}
      offset={{ right: 'var(--fos-toast-right, 24px)', bottom: 'var(--fos-toast-bottom, 24px)' }}
      mobileOffset={{ bottom: 'var(--fos-toast-bottom-mobile, 88px)', left: 16, right: 16 }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-start gap-2.5 rounded-lg border border-line bg-canvas px-4 py-3 text-body-s text-fg shadow-popover md:w-[356px]',
          title: 'font-medium',
          description: 'mt-0.5 text-caption text-fg-secondary',
          icon: 'mt-0.5 shrink-0',
          success: '[&_[data-icon]]:text-success',
          error: '[&_[data-icon]]:text-danger',
          warning: '[&_[data-icon]]:text-warning',
          info: '[&_[data-icon]]:text-accent',
          actionButton: 'ml-auto shrink-0 rounded-md px-2 text-label text-accent hover:bg-accent-subtle',
          cancelButton: 'shrink-0 rounded-md px-2 text-label text-fg-secondary hover:bg-elevated',
          closeButton: 'text-fg-muted',
        },
      }}
    />
  );
}
